<template>
	<div id="vehicle_create" class="fleet-form-main">
		<div :class="`loader${loaderClass}`" v-show="loading"></div>
		<div id="page-content-wrapper" class="admin-content-area">
			<template v-if="cantAccessPage === true">
				<div class="page-name">
					<span class="page-title" id="vehicleHeader" v-if="$route.params.id > 0">Update Asset</span>
					<span class="page-title" id="vehicleHeader" v-else>Add Asset</span>
					<button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
						<i class="fp-back"> </i>    Back
					</button>
				</div>
				<div class="container-fluid">
					<div class="admin-page-content asset-crud">
						<section class="internal-container border-top-table-fl">
							<form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="VehicleForm">
								<div class="list-sections">
									<h5 class="section-title"> Group Details </h5>
									<div class="form-row row-cols-md-4 row-cols-1">
										<div class="col form-group" v-if="isEnableAssetPool">
											<label class="control-label require" for="vehicle_group_id">Asset Group:</label>
											<v-select v-model="vehicle_group_id" name="vehicle_group_id" placeholder="Select Asset Group."
													label="text"
													:options="groupArr" @input="getVehicleType()">
											</v-select>
											<div class="field-error">{{vehicle_group_error}}</div>
										</div>
										<div class="col form-group">
											<label class="control-label require" for="vehicle_type_id">Asset Type:</label>
											<v-select v-model="vehicle_type_id" name="vehicle_type_id" placeholder="Select Asset Type."
														label="text"
														:options="vehicletypeArr" @input="getUnitNumber()">
											</v-select>
											<div class="field-error">{{vehicle_type_error_msg}}</div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="vehicle_manufacturer_id">Manufacturer:</label>
											<v-select v-model="vehicle_manufacturer_id" name="vehicle_manufacturer_id" placeholder="Select Manufacturer."
													label="text"
													:options="manufacturerArr">
											</v-select>
											<div class="field-error"></div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="vehicle_model_id">Model:</label>
											<v-select v-model="vehicle_model_id" name="vehicle_model_id" placeholder="Select Model."
													label="text"
													:options="modelArr">
											</v-select>
											<div class="field-error"></div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="year">Year:</label>
											<input type="text" class="form-control" v-model="year" id="year" placeholder="Enter Year" name="year" @keypress="isIntegerCheck($event)" @input="getUnitNumber()">
											<div class="field-error"></div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="location_id">Assigned Location:</label>
											<v-select v-model="location_id" name="location_id" placeholder="Select Assigned Location."
														label="text"
														:options="locationArr" @input="onLocationInput">
											</v-select>
											<div class="field-error"></div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="location_id">Physical Location:</label>
											<v-select v-model="physical_location_id" name="location_id" placeholder="Select Physical Location."
														label="text"
														:options="locationArr">
											</v-select>
											<div class="field-error"></div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="location_date">Location Change:</label>
											<div class="input-group">
												<date-picker placeholder="MM/DD/YYYY" id="location_date" name="location_date" v-model="location_date" :config="optionsLocationChange"></date-picker>
												<label for="location_date" class="fp-calendar input-calender-icon"></label>
											</div>
											<div class="field-error">{{ loc_date_added_error }}</div>
										</div>
										<div class="col form-group" v-if="isEnableAssetPool">
											<label class="control-label require" for="vehicle_pool_id">Asset Pool:</label>
											<v-select v-model="vehicle_pool_id" name="vehicle_pool_id" placeholder="Select Asset Pool."
														label="text" :disabled="disabledPool"
														:options="vehiclepoolArr" @input="getUnitNumber('pool')">
											</v-select>
											<div class="field-error" v-fp-html="asset_pool_error"></div>
										</div>
										<div class="col form-group" v-if="isEnableAssetPool">
											<label class="control-label" for="pool_date">Pool Change:</label>
											<div class="input-group">
												<date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="pool_date" name="pool_date" v-model="pool_date" :config="optionPoolChangeDate"></date-picker>
												<label for="pool_date" class="fp-calendar input-calender-icon"></label>
											</div>
											<div class="field-error">{{ pool_date_added_error }}</div>
										</div>
										<div class="col form-group">
											<label class="control-label require" for="gross_unit_weight">Gross Vehicle Weight:</label>
											<input type="text" class="form-control" v-model="gross_unit_weight" id="gross_unit_weight" placeholder="Enter Gross Unit Weight" name="gross_unit_weight" @keypress="isAmountCheck($event)">
											<label for="gross_unit_weight" class="customLBS"> &nbsp;LBS&nbsp;</label>
											<div class="field-error">{{ gross_unit_weight_error_msg }}</div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="tare_weight">Tare Weight:</label>
											<input type="text" class="form-control" v-model="tare_weight" id="tare_weight" placeholder="Enter Tare Weight" name="tare_weight">
											<label for="Tare Weight" class="customLBS"> &nbsp;LBS&nbsp;</label>
											<div class="field-error"></div>
										</div>
										<!-- <div class="col form-group">
											<label class="control-label" for="measurement_unit_id">UOM:</label>
											<v-select v-model="measurement_unit_id" name="measurement_unit_id" placeholder="Select Measurement Unit."
													label="text"
													:options="measurementunitArr">
											</v-select>
											<div class="field-error"></div>
										</div> -->
										<div class="col form-group" v-if="vendorEnable">
											<label class="control-label require" for="vendor_id">Vendor:</label>
											<v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false" :options="vendorArr" @search="onSearchVendor" placeholder="Select Vendor Code or Name" class="custom-ci-auto-search" @input="onVendorChange()">
												<template slot="no-options">
													Search Vendor Code or Name...
												</template>
												<template slot="option" slot-scope="option">
													<div class="d-center">
														{{ option.text }}
													</div>
												</template>
												<template slot="selected-option" slot-scope="option">
													<div class="selected d-center">
														{{ option.text }}
													</div>
												</template>
											</v-select>
											<div class="field-error">{{ vendor_error_msg }}</div>
										</div>
									</div>
								</div>
								<hr class="light-hr"/>
								<div class="list-sections">
									<h5 class="section-title"> Ownership Details </h5>
									<label class="control-label" v-if="$route.params.id > 0">  </label>
									<div class="form-row row-cols-md-4 row-cols-1">
										<div class="col form-group">
											<label class="control-label" for="vehicle_ownership_id">Asset Ownership:</label>
											<v-select v-model="vehicle_ownership_id" @input="changeOwnership($event);getUnitNumber('')" name="vehicle_ownership_id" placeholder="Select Asset Ownership."
													label="text"
													:options="vehicleownershipArr" :disabled="ownershipDisable">
											</v-select>
											<div class="field-error"></div>
										</div>
										<template>
											<div class="col form-group">
												<label class="control-label" for="purchased">Purchased:</label>
													<v-select
													class="close-remove"
													name="purchased"
													v-model="purchased"
													id="purchased" label="text"
													:options="purchasedArr"
													:required="true"
													></v-select>
													<div class="field-error">{{purchased_error_msg}}</div>
												<div class="field-error"></div>
											</div>
											<div class="col form-group">
												<label class="control-label" for="purchase_date">Purchase Date:</label>
												<div class="input-group">
													<date-picker placeholder="MM/DD/YYYY" id="purchase_date" name="purchase_date" v-model="purchase_date" :config="options"></date-picker>
													<label for="purchase_date" class="fp-calendar input-calender-icon"></label>
												</div>
												<div class="field-error">{{ purchase_date_error_msg }}</div>
											</div>
											<div class="col form-group">
												<label class="control-label" for="purchase_price">Purchase Price:</label>
												<input type="text" class="form-control" v-model="purchase_price" id="purchase_price"
												placeholder="Enter Purchase Price" name="purchase_price"
												@blur="purchase_price = leaveFocus($event)"
												@focus="purchase_price = enterVal($event)"
												@keypress="isAmountCheck($event)">
												<div class="field-error"></div>
											</div>
											<div class="col form-group">
												<label class="control-label" for="date_in_service">Date In Service:</label>
												<div class="input-group">
													<date-picker placeholder="MM/DD/YYYY" id="date_in_service" name="date_in_service" v-model="date_in_service" :config="options"></date-picker>
													<label for="date_in_service" class="fp-calendar input-calender-icon"></label>
												</div>
												<div class="field-error">{{service_date_error_msg}}</div>
											</div>
											<!-- <div class="col form-group">
												<label class="control-label" for="estimated_life">Estimated Life:</label>
												<input type="text" class="form-control" v-model="estimated_life" id="estimated_life" placeholder="Enter Estimated Life" name="estimated_life" @keypress="isIntegerCheck($event)">
												<div class="field-error"></div>
											</div> -->

											<!-- <div class="col form-group">
												<div class="custom-checkbox mt-4">
													<label class="checkbox-custom">
														<input type="checkbox" v-model="is_standard_unit" id="standard_unit" name="standard_unit">  Standard Unit
														<span class="checkmark"></span>
													</label>
												</div>
											</div> -->
											<!-- <div class="col form-group">
												<a v-if="$route.params.id > 0" href="javascript:void(0)" v-on:click="viewOwnership($route.params.id)" class="pull-left color-blue">
													<i class="fp-view"> </i> View More
												</a>
											</div> -->
											<template v-if="ownerShipCustomer">
											<div class="col form-group">
												<label class="control-label require" for="customer_id">Customer:</label>
												<v-select v-model="customer_id" name="customer_id"
													label="text" :filterable="false" :options="customerArr"
													@search="onSearchCustomer"
													placeholder="Select Customer" class='custom-ci-auto-search close-remove'>
													<template slot="no-options">
														Search Customer...
													</template>
													<template slot="option" slot-scope="option">
														<div class="d-center">
															{{ option.text }}
														</div>
													</template>
													<template slot="selected-option" slot-scope="option">
														<div class="selected d-center">
															{{ option.text }}
														</div>
													</template>
												</v-select>
												<div class="field-error">{{ customer_error_msg }}</div>
											</div>
										</template>
										</template>
									</div>
								</div>
								<hr class="light-hr"/>
								<div class="list-sections">
									<h5 class="section-title"> Asset Details </h5>
									<div class="form-row row-cols-md-4 row-cols-1">
										<div class="col form-group">
											<label class="control-label require" for="name">Name:</label>
											<input type="text" class="form-control" v-model="name" @keyup="name = name.toUpperCase()" id="name" placeholder="Enter Asset Name" name="name">
											<div class="field-error">{{name_error_msg}}</div>
										</div>
										<div class="col form-group">
											<label class="control-label require" for="unit_no">#Unit: &nbsp; <span v-if="po_unit_no != ''">(PO Unit: {{po_unit_no}} )</span></label>
											<input type="text" class="form-control" v-model="unit_no" @keyup="unit_no = unit_no.toUpperCase()" id="unit_no" placeholder="Enter Unit No" name="unit_no">
											<div class="field-error">{{unit_no_error_msg}}</div>
										</div>
										<div class="col form-group">
												<label class="control-label require" for="vin">VIN:</label>
												<input type="text" class="form-control" v-model="vin" @keyup="vin = vin.toUpperCase()" id="vin" placeholder="Enter VIN" name="vin">
												<div class="field-error">{{vin_error_msg}}</div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="unit_no">#Customer Unit:</label>
											<input type="text" class="form-control" v-model="customer_unit_no" @keyup="customer_unit_no = customer_unit_no.toUpperCase()" id="unit_no" placeholder="Enter Customer Unit No." name="customer_unit_no">
										</div>
										<div class="col form-group">
											<label class="control-label require" for="vehicle_status">Asset Status:</label>
											<v-select v-model="vehicle_status" @input="assetStatusChanged" name="vehicle_status" placeholder="Select Asset Status."
														label="text"
														:options="assetStatusArr">
											</v-select>
											<div class="field-error">{{asset_status_error}}</div>
										</div>
										<div class="col form-group">
											<label class="control-label" for="reading_date">Date Added:</label>
											<div class="input-group">
												<date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="date_added" name="date_added"
												v-model="date_added" :config="optionsDate"></date-picker>
												<label for="date_added" class="fp-calendar input-calender-icon"></label>
											</div>
											<div class="field-error">{{ date_added_error }}</div>
										</div>
										<div class="col form-group">
											<label class="control-label " for="odometer_device">Telematics Device:</label>
											<v-select
												name="odometer_device"
												placeholder="Select Telematics Device"
												v-model="odometerDevice"
												id="odometer_device" label="text"
												:options="odometerDeviceArr"
												:required="true"
												></v-select>
											<div class="field-error">{{odometer_device_error}}</div>
										</div>
									</div>
								</div>

								<template v-if="$route.params.id > 0">
									<hr class="light-hr"/>
									<div class="list-sections">
										<h5 class="section-title"> Recent Comments </h5>
										<h4> Comment Detail </h4>
										<template v-if="commentFound == true">
											<div class="comment-list-btm">
												<ul class="comment-box">
													<template v-if="cantViewCommnent == true">
														<template v-for="(comment,ind) in commentArr">
															<li :key="ind">
																<span class="labor-icon"> {{ comment.comment_by.substring(0,2).toUpperCase() }} </span>
																<img class="avatar" src="/static/images/default.jpg " alt="">
																<div class="comment-details">
																	<div class="comment-dec"><span class="user">{{ comment.comment_by }}</span><span>{{comment.comment_time}}</span> </div>
																	<p>{{comment.comment}}</p>
																</div>
															</li>
														</template>
													</template>
													<template v-else>
														<p class="no-data-field"> No comment available </p>
													</template>
												</ul>
											</div>
											<a href="javascript:void(0)" v-on:click="BackVehicleCommentList()" class="pull-left ownership-title">
												<i class="fp-view"> </i> View More
											</a>
										</template>
										<template v-else>
											<p class="no-data-field"> No comment found </p>
										</template>
									</div>
								</template>
								<div class="form-row row-cols-md-2 row-cols-1">
									<div class="alert alert-warning hide col form-group" id="alertError">
										<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
										<strong id="errorMsg" class="field-error"></strong>
									</div>
								</div>
								<div class="btn-groups">
									<button type="submit" id="createVehicleBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicle" >
									<i class="fp-reload"> </i>  Update
									</button>

									<button type="submit" id="createVehicleBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehicle" >
									<i class="fp-save"> </i>  Save
									</button>

									<button type="submit" id="createAndContinueVehicleBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehicle(flag='Save and Continue')" >
									<i class="fp-save-continue"> </i>  Save and Continue
									</button>

									<button type="submit" id="cancelVehicleBtn" class="btn btn-tertiary" v-on:click.prevent="goPreviousPath" >
									<i class="fp-close"> </i>  Cancel
									</button>
								</div>
							</form>
						</section>
					</div>
				</div>
			</template>
			<template v-else-if="cantAccessPage === false">
				<div class="container-fluid">
					<div class="bg-white text-center">
						<h1>
							Oops!</h1>
						<h2>
							403 </h2>
						<div class="error-details">
							Sorry!, You don't have permission to access this page.
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<loading-content></loading-content>
			</template>
			<app-footer></app-footer>
		</div>
	</div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
import moment from 'moment';
export default {
  name: "VehicleCreate",
  metaInfo() {
	return {
		title: (this.$route.params.id > 0)? "Update Asset | " +process.env.COPYRIGHT_NAME : "Create Asset | " +process.env.COPYRIGHT_NAME
	}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
	isEdit:false,
	permissions: [],
	cantAccessPage: "",
	name: "",
	unit_no: "",
	customer_unit_no:"",
	vin: "",
	vehicle_status: '',
	location_id: null,
	locationArr: [],
	vehicle_group_id: null,
	vehicle_group_error:'',
	groupArr: [],
	vehicle_manufacturer_id: null,
	manufacturerArr: [],
	vehicle_model_id: null,
	modelArr: [],
	year: "",
	gross_unit_weight: "",
	tare_weight: "",
	vehicle_type_id: null,
	vehicletypeArr: [],
	measurement_unit_id: null,
	measurementunitArr: [],
	vehicle_pool_id: null,
	vehiclepoolArr: [],
	vehicle_ownership_id: null,
	vehicleownershipArr: [],
	purchased: {value: "new", text: "NEW"},
	purchasedArr: [
		{
			value: "new",
			text: "NEW"
		},
		{
			value: "used",
			text: "USED"
		},
		{
			value: "none",
			text: "NONE"
		}
	],
	purchase_date: "",
	options: {
		format: 'MM/DD/YYYY',
		useCurrent: false,
	},
  optionsLocationChange: {
		format: 'MM/DD/YYYY',
		useCurrent: false,
    maxDate:new Date(),
	},
	date_in_service: "",
	purchase_price: "",
	estimated_life: "",
	loading:false,
	name_error_msg: "",
	unit_no_error_msg: "",
	vin_error_msg: "",
	purchased_error_msg: "",
	vehicle_type_error_msg: "",
	odometerDevice:null,
	odometer_device_error:"",
	asset_status_error:"",
	is_standard_unit:0,
	is_group_call:false,
  optionPoolChangeDate: {
		format: 'MM/DD/YYYY hh:mm:ss a',
		useCurrent: true,
    	//maxDate:new Date(),
		toolbarPlacement:'bottom',
		widgetPositioning: {
			horizontal: 'auto',
			vertical: 'bottom'
	  },
  },
	optionsDate: {
		format: 'MM/DD/YYYY hh:mm:ss a',
		useCurrent: false,
		toolbarPlacement:'bottom',
		widgetPositioning: {
			horizontal: 'auto',
			vertical: 'bottom'
		},
		showClose: true,
	},
	date_added:'',
	customerArr:[],
	customer_id:'',
	date_added_error:'',
	customer_error_msg:'',
	ownerShipCustomer:false,
	commentArr:[],
	cantViewCommnent:false,
	commentFound:false,
	approvedPo:0,
	asset_pool_error:'',
	pool_date_added_error:'',
	loc_date_added_error:'',
	location_date:'',
	pool_date:'',
	ownershipDisable:false,
	gross_unit_weight_error_msg:"",
	physical_location_id:null,
	redirectedfrom:'',
	vendorEnable:false,
	vendorArr:[],
	vendor_id:null,
	po_unit_no:'',
	purchase_date_error_msg:'',
	service_date_error_msg:'',
	disabledPool:false,
	prevAssetGroupId:0,
	isEnableAssetGroup:false,
	isEnableAssetPool:false,
  }),
  watch: {

	  //check permission change
	  permissions: function (permissions) {
		  var self = this;
		  if (permissions.length > 0) {
			  for (var i = 0; i < permissions.length; i++) {
				  if (permissions[i].name == 'add_asset') {
					  self.cantAccessPage = true;
				  }
				  if(permissions[i].name == 'view_asset_comment') {
					  self.cantViewCommnent = true;

				  }
			  }
        self.cantAccessPage = false; // doing this since, we are not allowing the user to create the vehicle from the system.
		  }
	  },

	vehicle_manufacturer_id: function(vehicle_manufacturer_id) {

		var self = this;

		if(self.vehicle_manufacturer_id == null || self.vehicle_manufacturer_id == ""){
			self.vehicle_model_id = null;
			self.modelArr = [];
			return;
		}

		$.ajax({
			url: process.env.ROOT_API + "/assetmodel/search",
			type: "GET",
			headers: this.ajxHeaders,
			crossDomain: true,
			dataType:"json",
			data:{
				id:vehicle_manufacturer_id.value,
			},
			success: function (data) {
				//if data is edit than dont make model id blank
				if ( !self.isEdit ) {
					// self.vehicle_model_id = "";
				}
				self.isEdit = false;
				if (data.status == "success") {

					if(self.is_group_call==true){
						self.is_group_call=false;
					}else{
						if ( self.approvedPo == 0){

							self.vehicle_model_id = null;

						}
						self.modelArr = data.content.vehiclemodels;

					}
				}

			},
			error: function (jqXHR, exception) {
				self.Registerbtn = "Register";
				if (jqXHR.status == 0) {
					self.error = "Remote server cannot be reached";
				} else {
				//redirect to login page if user not authenticated
				if (jqXHR.status == 401) {
					//clear previous data
					localStorage.removeItem("user_obj");
					localStorage.removeItem("tkn");

					self.$router.push("/");
				}
					self.error = jqXHR.responseJSON.message;
				}
			}
		});
	},

  },
  created: function() {
  },
//   beforeRouteLeave(to, from, next) {
//         var self = this;
//         self.left_view_edit_channel(from.fullPath);
//         next();
//   },
  mounted: function() {
		var self = this;
		this.getPermissions();
		self.loadFieldData(['enable_asset_group','enable_asset_pool']);
		self.loadVehicleSearchData();

		// In case user is redirected from Add Work Order...
		if(self.$route.params.newAsset != ''){
			self.name = self.$route.params.newAsset;
		}

		var path = window.location.pathname;
		var segments = path.split("/");
		if (segments[3]) {
			self.loadVehicle();
			self.getComments();
		}
		var dateTimeFormat = 'm/d/Y';
		var userObj = JSON.parse(localStorage.getItem("user_obj"));
		if(userObj != null){
			dateTimeFormat = userObj["date_format"] + " " + userObj["time_format"];
			if(dateTimeFormat != null){
				console.log(dateTimeFormat);
				//set date time format in optionsDate format of date picker
			}
		}
		if ( !segments[3]) {

			self.date_added = moment().format('MM/DD/YYYY hh:mm:ss a');
			self.location_date = moment().format("MM/DD/YYYY");
			self.pool_date = moment().format("MM/DD/YYYY hh:mm:ss a");
		}

		var webloc = window.location.href;

		 var decodeStr = "";

		if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {

			decodeStr = atob(this.$route.query.data)

		}

		var url = new URL(webloc+"?"+decodeStr);
		var approvedPo = url.searchParams.get("approvedPo");
		self.approvedPo = approvedPo;

		var from = url.searchParams.get("redirectFrom");
		self.redirectedfrom = url.searchParams.get("redirectFrom");

		setTimeout(function () {
			if(from == 'ApprovedOrder'){

				self.receiveOrderInfo(approvedPo);
				// self.fromWoView = true;
				// self.getWorkOrderDataForEstimate(woId,woiId);
			}
			if(from == 'osr'){
				self.vendorEnable = true;
			}
		},1000);

	//Join ViewEdit Channel
    self.join_view_edit_channel(segments[1],segments[2],segments[3]);

  },
  methods: {
	  onSearchVendor(search, loading) {
			var self = this;
			self.po_error_msg = "";
			if (search.length > 2) {

				loading(true);
				self.searchField(loading, search, 'vendor', '');
			}
		},
	  BackVehicleCommentList() {
		  var self = this;
		  var path = window.location.pathname;
		  var segments = path.split("/");
		  var string = "&id="+segments[3]+"&selectTab=17";

		  let routeData = self.$router.resolve({name: 'AssetView', query: {data: btoa(string)}});
		  window.open(routeData.href, '_blank');
	  },
	  getVehicleType(){
		  var self = this;

		  //change asset name
		  if ( self.vehicle_group_id.groupName != '' && self.vehicle_group_id.groupName != undefined){

			  self.name = self.vehicle_group_id.groupName;

		  }

		  $.ajax({
			  url: process.env.ROOT_API + "/assetgroup/" + self.vehicle_group_id.value,
			  type: "GET",
			  headers: this.ajxHeaders,
			  dataType: "json",
			  crossDomain: true,
			  success: function (data) {
				  //if data is edit than dont make model id blank
				  self.vehicle_manufacturer_id = {text: data.content.vmName, value: data.content.vehicle_manufacturer_id};
				  self.vehicle_model_id = {text: data.content.vmodelsName, value: data.content.vehicle_model_id};
				  self.vehicle_type_id={text: data.content.vtName, value: data.content.vehicle_type_id};
				  self.year=data.content.year;
				  self.is_group_call=true;

				  self.getUnitNumber();
			  },
			  error: function (jqXHR, exception) {
				  self.Registerbtn = "Register";
				  if (jqXHR.status == 0) {
					  self.error = "Remote server cannot be reached";
				  } else {
					  //redirect to login page if user not authenticated
					  if (jqXHR.status == 401) {
						  //clear previous data
						  localStorage.removeItem("user_obj");
						  localStorage.removeItem("tkn");

						  self.$router.push("/");
					  }
					  self.error = jqXHR.responseJSON.message;
				  }
			  }
		  });
	  },
	  getComments:function(){
		  var self = this;
		  var path = window.location.pathname;
		  var segments = path.split("/");

		  $.ajax({
			  url: process.env.ROOT_API + "/asset/get-asset-comment",
			  type: "GET",
			  crossDomain: true,
			  dataType: "json",
			  headers: this.ajxHeaders,
			  data: {
				  asset_id: segments[3],
				  record_limit:2,
			  },
			  success: function(data) {

				  if (data.status == "success") {

					  if (data.code == 200) {
						  self.commentArr=[]
						  self.commentArr = data.content.comments;;
						  self.commentFound = true;
					  }else{
						  self.commentFound = false;
					  }
				  }

			  },
			  error: function(jqXHR, exception) {
				  $("#myModal").modal("hide");
				  if (jqXHR.status == 0) {
					  self.error = "Remote server cannot be reached";
				  } else {
					  self.error = jqXHR.responseJSON.message;
				  }
			  }
		  });
	  },
	onSearchCustomer(search, loading) {
		var self = this;

		// use this in order to create new customer...

		if (search.length > 2) {

			loading(true);
			self.searchField(loading, search, 'customer', '');
		}
	},

	BackVehicleList() {
	  var self = this;
	  self.$router.push("/asset/list");
	},

	loadVehicleSearchData() {

		var self = this;
		$.ajax({
			url: process.env.ROOT_API + "/asset/search",
		   type: "GET",
			headers: this.ajxHeaders,
			crossDomain: true,
			dataType: 'json',
			success: function (data) {

				if (data.status == "success") {

					//self.statusArr = data.vehiclestatus;
					self.locationArr = data.location;
					self.groupArr = data.vehiclegroup;

					self.manufacturerArr = data.vehiclemanufacturer;
					// self.modelArr = data.vehiclemodel;
					self.vehicletypeArr = data.vehicletypes;

					self.measurementunitArr = data.measurementunit;
					self.vehiclepoolArr = data.vehiclepool;
					self.vehicleownershipArr = data.vehicleownership;

					if(self.redirectedfrom == 'osr'){
						if (self.groupArr.length > 0){
							for(var i =0;i < self.groupArr.length;i++){
								console.log(self.groupArr[i].groupName.toLowerCase());
								if (self.groupArr[i].groupName.toLowerCase() == 'outside rental'){

									self.vehicle_group_id = {text:self.groupArr[i].text,value:self.groupArr[i].value};
								}
							}
						}
						if (self.groupArr.length > 0){
							for(var j =0;j < self.vehiclepoolArr.length;j++){
								if (self.vehiclepoolArr[j].code == 'R1'){

									self.vehicle_pool_id = {text:self.vehiclepoolArr[j].text,value:self.vehiclepoolArr[j].value};
								}
							}
						}
						if (self.vehicleownershipArr.length > 0){
							for(var k =0;k < self.vehicleownershipArr.length;k++){
								if (self.vehicleownershipArr[k].code == 'R'){

									self.vehicle_ownership_id = {text:self.vehicleownershipArr[k].text,value:self.vehicleownershipArr[k].value};
								}
							}
						}
						self.name = 'Outside Rental';
						// self.fromWoView = true;
						// self.getWorkOrderDataForEstimate(woId,woiId);
					}
				}

			},
			error: function (jqXHR, exception) {
				self.Registerbtn = "Register";
				if (jqXHR.status == 0) {
					self.registerError = "Remote server cannot be reached";
				}
			}
		});
	},

	CreateVehicle(flag) {
	  var self = this;
	  var error = false;

	  self.vin = self.vin.trim();
	  self.unit_no = self.unit_no.trim();

	  self.name_error_msg = "";
	  self.unit_no_error_msg = "";
	  self.vin_error_msg = "";
	  self.purchased_error_msg = "";
	  self.vehicle_type_error_msg = "";
	  self.odometer_device_error = "";
	  self.asset_status_error = "";
	  self.customer_error_msg = "";
	  self.asset_pool_error = '';
	  self.vehicle_group_error = "";
	  self.gross_unit_weight_error_msg = "";
	  self.vendor_error_msg = '';
	  self.purchase_date_error_msg = '';
	  self.service_date_error_msg = '';
	  self.pool_date_added_error = '';
	  if( self.vehicle_pool_id != null && self.vehicle_pool_id != '' && self.vehicle_pool_id.code != 'INV'){

		if(self.purchase_date != null && self.purchase_date != ''){
			//removed date check as requested by david sandoval
			// var today = new Date();
			// if (Date.parse(self.date_in_service) < Date.parse(self.purchase_date)) {
			// 	self.purchase_date_error_msg = "Purchase Date should not be greater than In Service Date";
			// 	error = true;
			// }
			// if(self.pool_date != null && self.pool_date != ''){
      //
			//   if (Date.parse(moment(self.pool_date).format("MM/DD/YYYY")) < Date.parse(self.purchase_date)) {
			// 	  self.pool_date_added_error = "Pool Date should be greater than Purchase Date";
			// 	  error = true;
			//   }
			// }
		  }
	  }
	  // check vehicle pool id and pool date
	  var asset_pool = localStorage.getItem("vehicle_pool_id");
	  var pooldate = localStorage.getItem("pool_date");
	  if(self.isEnableAssetPool && asset_pool != self.vehicle_pool_id.code){
		if(pooldate == self.pool_date){
			self.pool_date_added_error = "You need to change Pool Date";
			error = true;
		}
	  }
	//removed date check as requested by david sandoval
	//   if(self.date_in_service != null && self.date_in_service != '' && self.purchase_date != ''){

	// 	// if (Date.parse(self.date_in_service) < Date.parse(self.purchase_date)) {
	// 	// 	self.service_date_error_msg = "Date In Service should be greater than Purchase Date";
	// 	// 	error = true;
	// 	// }
	//   }
	  if (!self.name || self.name == null || self.name == "") {
		self.name_error_msg = "Asset name is required.";
		error = true;
	  }

	  if (!self.unit_no || self.unit_no == null || self.unit_no == "") {
		self.unit_no_error_msg = "Unit No. is required.";
		error = true;
	  }

	  if (!self.vin || self.vin == null || self.vin == "") {
		self.vin_error_msg = "VIN is required.";
		error = true;
	  }
	  if (self.vin.length != 17) {
		self.vin_error_msg = "Invalid VIN 17 character required.";
		error = true;
	  }
	  if ( self.purchased == null || !self.purchased.value ) {
		self.purchased_error_msg = "Purchased is required.";
		error = true;
	  }

	  if ( self.isEnableAssetGroup && (self.vehicle_group_id == null || self.vehicle_group_id == '' || !self.vehicle_group_id.value) ) {
		self.vehicle_group_error = "Please select Asset Group.";
		error = true;
	  }
		console.log('error66', error);
	  if ( self.vehicle_status == null || self.vehicle_status == '' || !self.vehicle_status.value ) {
		self.asset_status_error = "Please select Asset Status.";
		error = true;
	  }
	  	console.log('error77', error);
	  if ( self.isEnableAssetPool && (self.vehicle_pool_id == null || self.vehicle_pool_id == '' || !self.vehicle_pool_id.value) ) {
		self.asset_pool_error = "Please select Asset Pool.";
		error = true;
	  }

	 /* if ( self.odometerDevice == null || !self.odometerDevice.value ) {
		self.odometer_device_error = "Please select Odometer Device.";
		error = true;
	  }*/
		console.log('error88', error);
	  if (self.vehicle_type_id == null || !self.vehicle_type_id.value) {
		self.vehicle_type_error_msg = "Asset type is required.";
		error = true;
	  }
		console.log('error99', error);
	  if(self.vehicle_ownership_id != null && self.vehicle_ownership_id.code == 'C'){

		  if (self.customer_id == null || self.customer_id == ''){
			  self.customer_error_msg = 'Customer Required';
			  error = true;
		  }
	  }
	  if(self.redirectedfrom == 'osr'){

		  if (self.vendor_id == null || self.vendor_id == ''){
			  self.vendor_error_msg = 'Vendor Required';
			  error = true;
		  }
	  }

	  if (self.gross_unit_weight != "" && self.gross_unit_weight != null) {
		  if (Number(self.gross_unit_weight) > 9999999) {
			  self.gross_unit_weight_error_msg = "Gross Vehicle Weight should not be greater than 9999999.";
			  error = true;
		  }
	  } else {
		self.gross_unit_weight_error_msg = "Gross Vehicle Weight is required.";
		error = true;
	  }

	  if (!error) {

			self.loading = true;
			var path = window.location.pathname;
			var segments = path.split("/");
			if (segments[3])
			{
				$("#createVehicleBtn").val("Updating ...");
				$("#createVehicleBtn").prop("disabled", true);
				$("#cancelVehicleBtn").prop("disabled",true);
			} else {
				if (flag == "Save and Continue") {

					$("#createAndContinueVehicleBtn").val("Saving ...");
					$("#createVehicleBtn").prop("disabled", true);
					$("#createAndContinueVehicleBtn").prop("disabled", true);
					$("#cancelVehicleBtn").prop("disabled",true);

				}else{

					$("#createVehicleBtn").val("Saving ...");
					$("#createVehicleBtn").prop("disabled", true);
					$("#createAndContinueVehicleBtn").prop("disabled", true);
					$("#cancelVehicleBtn").prop("disabled",true);
				}

			}

			var fields = $("#VehicleForm").serializeArray();
			if(self.vehicle_manufacturer_id == null || self.vehicle_manufacturer_id == "" ) {
				fields.push({name: "vehicle_manufacturer_id", value: ""});
			}else{
				fields.push({name: "vehicle_manufacturer_id", value: self.vehicle_manufacturer_id.value});
			}

			if(self.vehicle_model_id == null){
				fields.push({name: "vehicle_model_id", value: ""});
			}else{
				fields.push({name: "vehicle_model_id", value: self.vehicle_model_id.value});
			}

			if(self.vendor_id == null){
				fields.push({name: "vendor_id", value: ""});
			}else{
				fields.push({name: "vendor_id", value: self.vendor_id.value});
			}

			if(self.vehicle_group_id == null || self.vehicle_group_id == ''){
				fields.push({name: "vehicle_group_id", value: ""});
			}else{
				fields.push({name: "vehicle_group_id", value: self.vehicle_group_id.value});
			}

			if(self.vehicle_ownership_id == null){
				fields.push({name: "vehicle_ownership_id", value: ""});
			}else{
				fields.push({name: "vehicle_ownership_id", value: self.vehicle_ownership_id.value});
			}

			if(self.vehicle_pool_id == null){
				fields.push({name: "vehicle_pool_id", value: ""});
			}else{
				fields.push({name: "vehicle_pool_id", value: self.vehicle_pool_id.value});
			}
			if(self.vehicle_pool_id == null){
				fields.push({name: "vehicle_pool_name", value: ""});
			}else{
				fields.push({name: "vehicle_pool_name", value: self.vehicle_pool_id.code});
			}

			if(self.location_id == null){
				fields.push({name: "location_id", value: ""});
			}else{
				fields.push({name: "location_id", value: self.location_id.value});
			}

			if(self.physical_location_id == null){
				fields.push({name: "physical_location_id", value: ""});
			}else{
				fields.push({name: "physical_location_id", value: self.physical_location_id.value});
			}

			// if(self.measurement_unit_id == null){
			//     fields.push({name: "measurement_unit_id", value: ""});
			// }else{
			//     fields.push({name: "measurement_unit_id", value: self.measurement_unit_id.value});
			// }

			if(self.vehicle_status == null || self.vehicle_status == '' ) {
				fields.push({name: "vehicle_status", value: ""});
			}else{
				fields.push({name: "vehicle_status", value: self.vehicle_status.value});
			}

			if(self.customer_id == null || self.customer_id == '') {
				fields.push({name: "customer_id", value: ""});
			}else{
				fields.push({name: "customer_id", value: self.customer_id.value});
			}

			if(self.odometerDevice == null){
				fields.push({name: "odometer_device", value: ""});
			}else{
				fields.push({name: "odometer_device", value: self.odometerDevice.value});
			}

			if( self.vehicle_type_id == null || self.vehicle_type_id == "" ) {
				fields.push({name: "vehicle_type_id", value: "" });
			}else{
				fields.push({name: "vehicle_type_id", value: self.vehicle_type_id.value});
			}

			if( self.purchase_price == null || self.purchase_price == "" ) {
				fields.push({name: "purchase_price", value: "" });
			}else{
				fields.push({name: "purchase_price", value: self.removeFormat(self.purchase_price)});
			}

			fields.push({name: "purchased", value: self.purchased.value});
			fields.push({ name: "id", value: segments[3] });

			if ( self.approvedPo > 0){
				fields.push({ name: "approvedPo", value: self.approvedPo });
			}

			if($('#standard_unit').prop('checked')){
				self.is_standard_unit = 1;
			}else{
				self.is_standard_unit = 0;
			}

			fields.push({name: "update_feature", value: 0 });
			// check if user have updated group or not so need to capture the
			if (segments[3])
			{
				if ( self.isEnableAssetGroup && self.prevAssetGroupId != self.vehicle_group_id.value ) {
					if (confirm("Do you wants to update Asset features?")) {
						fields.push({name: "update_feature", value: 1 });
					}
				}
			}

			fields.push({name: "is_standard", value: self.is_standard_unit});

			$.ajax({
				url: process.env.ROOT_API + "/asset/create",
				type: "POST",
				data: fields,
				headers: this.ajxHeaders,
				dataType: "json",
				success: function (data) {
					self.loading = false;
					if (segments[3])
					{
						$("#createVehicleBtn").val("Update");
						$("#createVehicleBtn").prop("disabled", false);
						$("#cancelVehicleBtn").prop("disabled",false);
					} else {
						if (flag == "Save and Continue") {

							$("#createAndContinueVehicleBtn").val("Save and Continue");
							$("#createVehicleBtn").prop("disabled", false);
							$("#createAndContinueVehicleBtn").prop("disabled", false);
							$("#cancelVehicleBtn").prop("disabled",false);

						}else{

							$("#createVehicleBtn").val("Save");
							$("#createVehicleBtn").prop("disabled", false);
							$("#createAndContinueVehicleBtn").prop("disabled", false);
							$("#cancelVehicleBtn").prop("disabled",false);

						}
					}

					if (data.status == "success") {

						if (flag == "Save and Continue") {

							$("#VehicleForm").trigger("reset");
							self.name = "";
							self.unit_no = "";
							self.vin = "";
							self.vehicle_manufacturer_id = null;
							// self.manufacturerArr = "";
							self.vehicle_model_id = null;
							// self.modelArr = "";
							self.vehicle_type_id = null;
							// self.vehicletypeArr = "";
							self.location_id = null;
							// self.locationArr = "";
							self.vehicle_status = '';
							self.vehicle_group_id = null;
							// self.groupArr = "";
							self.year = "";
							self.gross_unit_weight = "";
							// self.measurement_unit_id = null;
							// self.measurementunitArr = "";
							self.vehicle_pool_id = null;
							// self.vehiclepoolArr = "";
							self.vehicle_ownership_id = null;
							// self.vehicleownershipArr = "";
							self.purchased = {text:'New',value:'new'};
							self.purchase_date = "";
							self.purchase_price = "";
							self.date_in_service = "";
							self.estimated_life = "";
							self.odometerDevice = null;
							self.is_standard_unit = 0;
							self.customer_id = null;
							self.date_added = moment().format('MM/DD/YYYY hh:mm:ss a');
							self.physical_location_id = null;

						}else{

							if(self.$route.params.redirectFrom == 'MaintenanceSchedule' && self.$route.params.redirectFrom != undefined){

								self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Schedule Maintenance', assetId: data.content.id, assetName: self.name, assetType: self.vehicle_type_id, assetUnitNo: self.unit_no, assetLocation:self.location_id}});

							}else if(self.$route.params.redirectFrom == 'WorkOrderCreate' && self.$route.params.redirectFrom != undefined){

								self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Work Order Asset', assetId: data.content.id, assetName: self.name, assetType: self.vehicle_type_id, assetUnitNo: self.unit_no, assetLocation:self.location_id}});

							}else if(self.$route.params.redirectFrom == 'CustomerEstimateCreate' && self.$route.params.redirectFrom != undefined){

								self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Customer Estimate Asset', assetId: data.content.id, assetName: self.name, assetType: self.vehicle_type_id, assetUnitNo: self.unit_no, assetLocation:self.location_id}});

							}else if(self.$route.params.redirectFrom == 'VendorEstimateCreate' && self.$route.params.redirectFrom != undefined){

								self.$router.push({name: self.$route.params.redirectFrom,params:{redirectTo: 'Add Vendor Estimate Asset', assetId: data.content.id, assetName: self.name, assetType: self.vehicle_type_id, assetUnitNo: self.unit_no, assetLocation:self.location_id}});

							}else{

								self.$router.push({name: 'AssetView',params:{id:data.content.id}});

							}

						}

					} else {
						if (data.content.length > 0) {
							var err = "";
							for (var i = 0; i < data.content.length; i++) {
								err += data.content[i] + "<br>";
							}
							$("#errorMsg").html(err);
							$(".alert-warning").toggleClass("show");
							setTimeout(function () {
								$(".alert-warning").removeClass("show");
								$(".alert-warning").addClass("hide");
							}, 10000);
						}
					}
				},
				error: function (jqXHR, exception) {

					self.loading = false;
					if (segments[3])
					{
						$("#createVehicleBtn").val("Update");
						$("#createVehicleBtn").prop("disabled", false);
						$("#cancelVehicleBtn").prop("disabled",false);

					} else {
						if (flag == "Save and Continue") {

							$("#VehicleForm").trigger("reset");


							$("#createAndContinueVehicleBtn").val("Save and Continue");
							$("#createVehicleBtn").prop("disabled", false);
							$("#createAndContinueVehicleBtn").prop("disabled", false);
							$("#cancelVehicleBtn").prop("disabled",false);

						}else{

							$("#createVehicleBtn").val("Save");
							$("#createVehicleBtn").prop("disabled", false);
							$("#createAndContinueVehicleBtn").prop("disabled", false);
							$("#cancelVehicleBtn").prop("disabled",false);

						}
					}
					if (jqXHR.status == 0) {
						self.errorMsg = "Remote server cannot be reached";
					} else {
						//redirect to login page if user not authenticated
						if (jqXHR.status == 401) {
							//clear previous data
							localStorage.removeItem("user_obj");
							localStorage.removeItem("tkn");
							//EventBus.$emit("logged-in", true, "", "");
							self.$router.push("/");
						}
						$("#errorMsg").html(jqXHR.responseJSON.message);
						$(".alert-warning").toggleClass("show");
						setTimeout(function () {
							$(".alert-warning").removeClass("show");
							$(".alert-warning").addClass("hide");
						}, 10000);
					}
				}
			});
	  }else{
			self.errorValidationFocus();
	  }
	},

	changeOwnership: function(evt){
		var self = this;
		var path = window.location.pathname;
		var segments = path.split("/");
		console.log(evt);
		if (evt.code != 'C'){

			if ( !segments[3])
			{
				self.customerArr = [];
				self.customer_id = null;
				self.customer_error_msg = '';
			}
			self.ownerShipCustomer = false;

		}else{
			self.ownerShipCustomer = true;
		}

		if ( evt.code == 'S'){

			var i = 0;
			var j = 0;
			self.assetStatusArr.forEach(function(e){

				console.log(e);
				if ( e.value == 'Sold'){

					j = i;
				}
				i++;
			})
			self.vehicle_status = self.assetStatusArr[j];
		}

	},

	loadVehicle() {
		var path = window.location.pathname;
		var segments = path.split("/");
		var self = this;
		self.loading = true;
		$.ajax({
			url: process.env.ROOT_API + "/asset/" + segments[3],
			type: "GET",
			headers: this.ajxHeaders,
			data:{
            	action_flag : 'edit', // pass action for notify: view, edit
            	is_notify_flag : true // notify if user viewing or editing
        	},
			dataType: "json",
			success: function (data) {
				self.loading = false;
				console.log(data);

				if (data.status == "success") {

					self.isEdit = true;
					self.name = data.content.name;
					self.unit_no = data.content.unit_no;
					self.customer_unit_no = data.content.customer_unit_no;
					self.vin = data.content.vin;
					self.year = data.content.year;
					self.gross_unit_weight = data.content.gross_unit_weight;
					self.date_added = data.content.date_added;
					self.purchased = {
						value: data.content.purchased,
						text: self.formatString(data.content.purchased)
					};
					self.purchase_date = data.content.purchase_date;
					self.purchase_price = self.amountFormat(data.content.purchase_price);
					self.date_in_service = data.content.date_in_service;
					self.estimated_life = data.content.estimated_life;

					if ( data.content.vehicle_status == "" ) {
						self.vehicle_status = null;
					} else {
						self.vehicle_status = {value: data.content.vehicle_status, text: self.formatString(data.content.vehicle_status)};
					}

					if(data.content.vehicle_group_id == null) {
						self.vehicle_group_id = null;
					}else{
						self.vehicle_group_id = {value: data.content.vehicle_group_id, text: data.content.vgName + " (" + data.content.vgCode +")"};
						self.prevAssetGroupId = data.content.vehicle_group_id;
					}

					self.vehicle_type_id = {value: data.content.vehicle_type_id, text: self.titleCase(data.content.vtName + " (" + data.content.vtCode +")")};


					if(data.content.location_id == null) {
						self.location_id = "";
					}else{
						self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locName + " (" + data.content.locCode +")")};
					}

					if(data.content.physical_location_id == null) {
						self.physical_location_id = "";
					}else{
						self.physical_location_id = {value: data.content.location_id, text: self.titleCase(data.content.plName + " (" + data.content.plCode +")")};
					}

					if(data.content.vehicle_manufacturer_id == null) {
						self.vehicle_manufacturer_id = "";
					}else{
						self.vehicle_manufacturer_id = {value: data.content.vehicle_manufacturer_id, text: self.titleCase(data.content.vmName + " (" + data.content.vmCode +")")};
					}

					if(data.content.vehicle_model_id == null) {
						self.vehicle_model_id = null;
					}else{
						self.vehicle_model_id = {value: data.content.vehicle_model_id, text: self.titleCase(data.content.vmodelsName + " (" + data.content.vmodelsCode +")")};
					}

					// if(data.content.measurement_unit_id == null) {
					//     self.measurement_unit_id = null;
					// }else{
					//     self.measurement_unit_id = {value: data.content.measurement_unit_id, text: self.titleCase(data.content.muName + " (" + data.content.muSymbol +")")};
					// }

					if(data.content.ownership == null || data.content.ownership == '') {
						self.vehicle_ownership_id = "";
					}else{
						self.vehicle_ownership_id = {value: data.content.ownership, text: data.content.ownership + " | " + self.titleCase(data.content.ownershipName), code:data.content.ownership};
						self.ownershipDisable = true; //disable ownership selection
					}

					if(data.content.custId == null) {
						self.customer_id = "";
					}else{
						self.customer_id = {value: data.content.custId, text: data.content.custCode+' | '+self.titleCase(data.content.custName +' | '+ data.content.custStage)};
					}

					if ( data.content.ownership == 'C'){
						self.ownerShipCustomer = true;
					}

					if(data.content.vehicle_pool_id == null) {
						self.vehicle_pool_id = null;
					}else{
						self.vehicle_pool_id = {value: data.content.vehicle_pool_id, text: self.titleCase(data.content.vpCode + " | " + data.content.vpName),code:data.content.vpCode};
						localStorage.setItem("vehicle_pool_id",data.content.vpCode);
					}

					if ( data.content.odometer_device == null) {
						self.odometerDevice = null;
					}else{
						self.odometerDevice = {value: data.content.odometer_device, text: self.titleCase(data.content.odometer_device)};
					}

					if (data.content.location_change_date != ''){

						self.location_date = data.content.location_change_date;

					}

					if (data.content.pool_change_date != ''){

						self.pool_date = data.content.pool_change_date;
						localStorage.setItem("pool_date",data.content.pool_change_date)
					}
					if (self.vehicle_ownership_id.code == 'R'){
						self.vendorEnable = true;
					}
					if ( data.content.vendor_id == null) {
						self.vendor_id = null;
					}else{
						self.vendor_id = {value: data.content.vendor_id, text: data.content.vendorCode+' | '+self.titleCase(data.content.vendorName)};
					}


					self.is_standard_unit = data.content.is_standard_unit;
					self.asset_pool_error = '';
					if (data.content.current_contract.reserved != undefined && data.content.current_contract.reserved == 'true'){
						self.asset_pool_error = 'Unit having active contract '+data.content.current_contract.resCode;
						self.disabledPool = true;
					}else{
						self.asset_pool_error = '';
						self.disabledPool = false;
					}

				}
			},
			error: function (jqXHR, exception) {
				self.loading = false;
				if (jqXHR.status == 0) {
					self.errorMsg = "Remote server cannot be reached";
				} else {
					//redirect to login page if user not authenticated
					if (jqXHR.status == 401) {
						//clear previous data
						localStorage.removeItem("user_obj");
						localStorage.removeItem("tkn");
						//EventBus.$emit("logged-in", true, "", "");
						self.$router.push("/");
					}
					self.error = jqXHR.responseJSON.message;
				}
			}
		});
	},
	assetStatusChanged: function(evt){

		var self = this;
		self.ownershipDisable = false;

		console.log(evt.text);
		if (evt.text == 'Sold'){

			var i = 0;
			var j = 0;
			self.vehicleownershipArr.forEach(function(e){

				console.log(e);
				if ( e.code == 'S'){

					j = i;
				}
				i++;
			})
			self.vehicle_ownership_id = self.vehicleownershipArr[j];
		}
	},
	formatString(data) {
		var self = this;
		var value = data.replace(/_/g, " ");
		var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
			return letter.toUpperCase();
		});
		return upp.toUpperCase();
	},
	titleCase(str) {
		if (str == null){
			return;
		} else{
			var value = str.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	},
	viewOwnership:function(id){
		var self = this;

		// var string = "&customer_id="+self.customer_id.value+"&custName="+self.customer_id.text;
		let routeData = self.$router.resolve({name: 'AssetView', params: {id: id},query:{from:'owner'}});
		window.open(routeData.href, '_blank');
	},
	receiveOrderInfo: function(id){
		var self = this;

		$.ajax({
			url: process.env.ROOT_API + "/receive-order/info/"+id,
			type: "GET",
			crossDomain: true,
			dataType: "json",
			headers: this.ajxHeaders,
			data: {
				approvedPo: id,
			},
			success: function(data) {

				if (data.status == "success") {

					if (data.content.ship_loc_id == null) {
						self.location_id = null;
					} else {
						self.location_id = {
							value: data.content.ship_loc_id,
							text: self.titleCase(data.content.ship_loc_name + " (" + data.content.ship_loc_code + ")")
						};
					}

					if (data.content.unit_no != ''){
						self.po_unit_no =  data.content.unit_no;
					}
					if (data.content.manufacturerId == null) {
						self.vehicle_manufacturer_id = null;
					} else {
						self.vehicle_manufacturer_id = {
							value: data.content.manufacturerId,
							text: self.titleCase(data.content.manufacturerName + " (" + data.content.manufacturerCode + ")")
						};
					}

					if (data.content.modelId == null) {
						self.vehicle_model_id = null;
					} else {
						self.vehicle_model_id = {
							value: data.content.modelId,
							text: self.titleCase(data.content.modelName + " (" + data.content.modelCode + ")")
						};
					}

					if (data.content.poolId == null) {
						self.vehicle_pool_id = null;
					} else {
						self.vehicle_pool_id = {
							value: data.content.poolId,
							text: self.titleCase(data.content.poolName + " (" + data.content.poolCode + ")")
						};
					}

					if (data.content.typeId == null) {
						self.vehicle_type_id = null;
					} else {
						self.vehicle_type_id = {
							value: data.content.typeId,
							text: self.titleCase(data.content.typeName + " (" + data.content.typeCode + ")")
						};

					}

					self.vehicle_aquisition = data.content.requisition_no;
					self.description = data.content.description;
					self.year = data.content.year;
					self.gross_unit_weight = data.content.licenced_gvw;
					self.name = self.titleCase(data.content.vehicleName);
					//populate purchase price from unit price of po requisition
					if (data.content.unit_price != undefined && data.content.unit_price != null) {
						self.purchase_price = self.amountFormat(data.content.unit_price);
					}

				}

			},
			error: function(jqXHR, exception) {
				$("#myModal").modal("hide");
				if (jqXHR.status == 0) {
					self.error = "Remote server cannot be reached";
				} else {
					self.error = jqXHR.responseJSON.message;
				}
			}
		});
	},
	onLocationInput() {
		var self = this;
		if (self.location_id != null && self.location_id != "") {
			if (self.physical_location_id == null || !self.physical_location_id.value) {
				self.physical_location_id = self.location_id;
			}
		}
	},
	getUnitNumber:function(from = ''){
		var self = this;
		var path = window.location.pathname;
		var segments = path.split("/");
		var id = 0;
		if (segments[3]){
			id = segments[3];
		}
		// if (from != '' && from == 'pool' && segments[3]){
		//     return;
		// }
		if (segments[3]){
			return;
		}
		// if (!segments[3]) {
			//Change unit number while edit the asset if asset type and all changes
			if (self.vehicle_group_id != null && self.vehicle_type_id != null && self.vehicle_pool_id != null && self.vehicle_group_id != '' && self.vehicle_type_id != '' && self.vehicle_pool_id != ''){
				var vehicle_ownership_id = '';
				if (self.vehicle_ownership_id != null && self.vehicle_ownership_id.value != undefined){
					vehicle_ownership_id = self.vehicle_ownership_id.value;
				}

				$.ajax({
					url: process.env.ROOT_API + "/unit-number/generate",
					type: "GET",
					headers: this.ajxHeaders,
					data:{
						pool_id:self.vehicle_pool_id.value,
						type:self.vehicle_type_id.value,
						group:self.vehicle_group_id.value,
						own:vehicle_ownership_id,
						year:self.year,
						id:id
					},
					crossDomain: true,
					dataType: 'json',
					success: function (data) {

						if (data.status == "success") {
							self.unit_no = data.content;
						}

					},
					error: function (jqXHR, exception) {
						self.Registerbtn = "Register";
						if (jqXHR.status == 0) {
							self.registerError = "Remote server cannot be reached";
						}
					}
				});
			}
		// }
	}
  }
};
</script>
<style scoped>
.customLBS{
	background-color: gainsboro;
	top: 28px !important;
	position: absolute;
	right: 10px;
	z-index: 9;
	font-size: 1rem;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetCreate.vue